import { PropertyTableProps } from './types';
import PropertyTable from './OriginalTable';

const OverviewPropertyTable = ({ propertyList, onSort, isGridView }: PropertyTableProps) => {
    return <PropertyTable propertyList={propertyList} onSort={onSort} isForCompetitor={false} shouldShowDetail={true} isGridView={isGridView} />;
};

export default OverviewPropertyTable;
